import React from 'react';
import { useIsMobile } from '../../../../../base/hooks';

import { SpecialityAutocompleteDesktop } from './SpecialityAutocompleteDesktop';
import { SpecialityAutocompleteMobile } from './SpecialityAutocompleteMobile';

export const SpecialityAutocomplete = () => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return <SpecialityAutocompleteMobile />;
    }

    return <SpecialityAutocompleteDesktop />;
};
